export default __webpack_public_path__ + "static/Walter Wolf_MiniBio-01426acecf6b1a8d946ca223dce1730a.webp";